// extracted by mini-css-extract-plugin
export default {"root":"NotCheckedCell_root__XkZzL"};